<template>
  <v-footer dark color="primary" class="justify-center">
    <p class="ma-0 pa-1 text-center text-caption">
      Data & Images provided by:
      <a class="accent--text" href="https://www.themoviedb.org/" target="_blank"
        >The Movie Database</a
      >
    </p>
  </v-footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style lang="scss"></style>
